var React = require('react');

function IconLesedauer (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22 11.8333C22 17.2642 17.5975 21.6667 12.1667 21.6667C6.73582 21.6667 2.33334 17.2642 2.33334 11.8333C2.33334 6.40247 6.73582 2 12.1667 2C17.5975 2 22 6.40247 22 11.8333Z","stroke":"currentColor","style":{"fill":"transparent"},"strokeWidth":"1.5","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M12.1667 11.8106V4.80302","stroke":"currentColor","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M12.1667 11.8106L16.9673 14.5817","stroke":"currentColor","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","key":2})]);
}

IconLesedauer.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconLesedauer;

IconLesedauer.default = IconLesedauer;
